import { mobileMatchMedia } from './common';

const fixedTop = (nav) => {
  nav.classList.add('_fixed');
};
const staticTop = (nav) => {
  nav.classList.remove('_fixed');
};
// IntersectionObserverオブジェクトを作成
// 交差時に実行するコールバック関数を渡す
const observerFunction = (entries) => {
  entries.forEach((entry) => {
    const nav = document.querySelector('.js-navOTA');
    if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
      fixedTop(nav);
    } else {
      staticTop(nav);
    }
  });
};
const spObserver = new IntersectionObserver(observerFunction, {
  root: null,
  rootMargin: '-53px 0px 0px 0px',
  threshold: 0,
});
const pcObserver = new IntersectionObserver(observerFunction, {
  root: null,
  rootMargin: '-59px 0px 0px 0px',
  threshold: 0,
});
const executeObserver = (observer) => {
  observer.observe(document.querySelector('.js-navOTAWrap'));
};
const checkMedia = () => {
  if (mobileMatchMedia.matches) {
    pcObserver.unobserve(document.querySelector('.js-navOTAWrap'));
    executeObserver(spObserver);
  } else {
    spObserver.unobserve(document.querySelector('.js-navOTAWrap'));
    executeObserver(pcObserver);
  }
};

export default function navOTA() {
  const navElement = document.querySelector('.js-navOTAWrap');
  if (navElement === null) return;
  executeObserver(spObserver);
  executeObserver(pcObserver);
  mobileMatchMedia.addListener(checkMedia);
}
